<template>
    <form @submit.prevent="mobileVerifyLogin" class="mobile-form">
      <div class="form-group">
        <div v-if="formError" class="error-container">
          <p class="error">{{ formError }}</p>
        </div>
        <div class="headings">
          <h1 class="verification-heading">
            {{ $t("Verify Mobile Number") }}
          </h1>
          <p class="email-verification">
            {{ $t("Please Enter 6 Digit OTP sent to your Mobile Number") }}
          </p>
        </div>
        <div class="vlive-form">
          <p class="vlive-user-input"> {{ userMobileno }} </p>
          <P class="change-button" @click="changeFrom('mobileno')">{{ $t("change") }}</P>
        </div>  
        <div class="form-control">
          <PinLayout ref="pinLayout" value="" pinCount="6" @onChange="updatePin" @onCompleted="pinCompleted"
            class="pinboxes" />  
        </div>
        <div class="form-options">
          <p v-if="timeRemaining" class="resendText">
            {{ $t("Resend Code in") }} <span style="color:#777; font-size: 14px;" :class="{ grayText: timeRemaining }">00:{{ timeRemaining }}</span>
          </p>
          <p @click="resendOtpLink" v-else class="resendOtpLink">
            {{ $t("Didn't receive OTP?") }} <span class="grayText cursor_pointer">{{ $t("Resend") }}</span>
          </p>
        </div>
      </div>  
      <div class="disclamier">
        <p class="otp_error_text">{{ $t("otp text") }}</p>
      </div>  
      <div class="login-button" v-if="buttonActive">
        <button class="button-primary signup verify" type="submit">
          <Loading class="loader" v-if="loader" :size="'16px'"></Loading>
          <span>{{ $t("Verify") }}</span>          
        </button>
        <div class="dynamic-password button-primary" v-if="activeMobile" @click="changeToLogin('mobileno')">
          <p>{{ $t("USE PASSWORD") }}</p>
        </div>
      </div>
      <div class="placeholder-button" v-else>
        <DotFlashing />
      </div>
    </form>
  </template>
      
  <script>
  import Utility from "@/mixins/Utility.js";
  import { eventBus } from "@/eventBus";
  import { store } from "@/store/store";
  import { mapGetters, mapActions } from "vuex";
  import { showSnackBar } from "@/utilities";
  import { _providerId } from "../../../../provider-config";
  
  export default {
    props: ["input", "formData"],
    data() {
      return {
        userMobileno: "",
        userPin: [],
        profilePin: "",
        formError: null,
        localDisplayLang: null,
        inputType: "'text'",
        activeMobile: false,
        timeRemaining: "60",
        otpTimer: null,
        isMobileVerificationPending: false,
        loader: false,
        buttonActive: false,
      };
    },
    watch: {
      formError(val) {
        if (val) {
          setTimeout(() => {
            this.formError = null;
          }, 5000);
        }
      },
      timeRemaining: {
        handler(newValue, oldValue) {
          if (newValue === "") {
            this.clearOtpInterval(newValue);
          }
        },
      },
      deep: true,
  
    },
  
    computed: {
      ...mapGetters(["country", "appConfig", "subscriptionList"]),
    },
  
    created() {
      this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
      eventBus.$on("auth-close", () => {
        this.$emit("closePopup");
      });
  
      eventBus.$on("login-response", (response) => {
            if (response.reason) {
                  if (response.errorcode == 6110) {
                    this.isMobileVerificationPending = true;
                  } else {
                    this.formError = this.$t(response.reason);
                    this.$refs.pinLayout.clearOtpBoxes();
                  }
            } else {
              localStorage.setItem("sessionToken", response.success);
                localStorage.setItem("isMultipleProfileEnabled", this.appConfig.featureEnabled.isMobileOtpLoginEnabled);
                if (this.appConfig.featureEnabled.isMultipleProfileEnabled) {
                  let currentLanguage = this.getCurrentLanguageUrlBase();
  
  
                  this.listProfiles().then((profileResponse) => {
                    if (profileResponse.data && profileResponse.data.totalcount > 1) {
                      this.parentalControlStatus()
                      .then((data) => {
                        if (data.reason) {
                          return;
                        }
                        if (data.data.isenabled) {
                          localStorage.setItem("parentalControlEnabled", data.data.isenabled);
                        }
                      });
                      this.$router.push({name: "switchProfile", params: { lang: currentLanguage, renderCancel: false }, query:{"islogin": true}})
                      } else {
              
                      this.$router.push({path: window.storeAfterLoginPath ? window.storeAfterLoginPath : this.$route.path });
                      if ( window.selectedPlanInfomationRouting && !(this.subscriptionList && this.subscriptionList.length > 0)) {
                        setTimeout (() => {
                          eventBus.$emit("open-home-rzp-modal", window.selectedPlanInfomationRouting);
                          window.selectedPlanInfomationRouting = "";
                        }, 500)
                      }
                      window.storeAfterLoginPath = "";                    
  
                    }
                  });
            }
          }
      })
      eventBus.$on("signup-lookup-res", (res) => {
        this.buttonActive = true;
        this.activeMobile = res.isPasswordSet;
      })
      eventBus.$on("loader", (state) => {
        this.loader = state;
      });
  
    },
    mounted() {
      this.userMobileno = this.input;
      this.loginOtpPayload();
      this.loginOtpPayload = this.throttle(this.loginOtpPayload, 3000);
      this.setupOtpInterval();
      this.setupForm();
      this.setupPin();
    },
    methods: {
      ...mapActions(["login", "resendLink", "newEmailconfirm", "listProfiles", "parentalControlStatus"]),
  
  
      throttle(fn, wait) {
        let throttled = false;
        return function (...args) {
          if (!throttled) {
            fn.apply(this, args);
            throttled = true;
            setTimeout(() => {
              throttled = false;
            }, wait);
          }
        }
      },
  
      clearOtpInterval(timeRemaining) {
        this.timeRemaining = timeRemaining;
        clearInterval(this.otpTimer);
        this.otpTimer = null;
      },
      setupOtpInterval() {
        this.timeRemaining = "60";
        this.otpTimer = setInterval(() => {
          let timeRemaining = parseInt(this.timeRemaining);
          if (isNaN(timeRemaining) || timeRemaining <= 0) {
            this.clearOtpInterval("");
          } else {
            timeRemaining = timeRemaining - 1;
  
            let slug = timeRemaining.toString();
            if (slug.length < 2) {
              slug = "0" + slug;
            }
            this.timeRemaining = slug;
          }
        }, 1000);
      },
  
      open(newValue, oldValue) {
        if (newValue) {
          this.setupOtpInterval();
        } else {
          this.clearOtpInterval("");
        }
      },
  
      verificationResendSms() {
        let payload = {
          mobileno: this.userMobileno,
        }
        this.resendLink(payload)
          .then((response) => {
            if (response.data && response.data.success) {
             
            }  else if (response.data && response.data.errorcode === 5212) {
              this.formError = showSnackBar(this.$t(response.data.reason), this.$t('DISMISS'));
            }
          })
      },
  
  
      resendCaptcha() {
  
        if (this.appConfig.featureEnabled.isCaptchaEnabled) {
  
          let template = {
            input: this.inputtype === 'Email' ? "email" : 'mobile',
            formType: "verifyResendCaptcha",
            mobileno: this.userMobileno ? this.userMobileno : ""
          };
  
          this.$emit("change", template);
        } else {
  
        }
  
      },
  
  
      changeToLogin(data) {
        let info = {
          formType: "userPasswordLogin",
          inputtype: data
        };
        this.$emit("change", info);
      },
  
      setupForm() {
        console.log("getinput", this.input)
  
        let input = document.getElementById("userMobileno");
        input.style.backgroundColor = "#5C5C5D";
        input.style.opacity = "0.3";
      },
  
      pinCompleted(pin) {
        this.profilePin = pin
      },
      updatePin(value) {
        this.userPin = value.split('')
      },
  
      changeFrom(data) {
        let info = {
          formType: "lookup",
          inputtype: data
        };
        this.$emit("change", info);
      },
  
  
  
      setupPin() {
        setTimeout(() => {
          this.getId = document.getElementById("pininputs");
          this.pinFunctionality(this.getId);
        }, 1000);
      },
  
      grabPin() {
        if (this.userPin.length > 3) {
          let pin = "";
          this.userPin.forEach((element) => {
            pin += element;
          });
          this.profilePin = pin;
        }
      },
  
      resendOtpLink() {
        this.loginOtpPayload(); 
        this.setupOtpInterval();
        this.timeRemaining = 60;
        this.$refs.pinLayout.clearOtpBoxes();
      },
  
      loginOtpPayload() {
        localStorage.setItem("getUserPasswordNumber", this.userMobileno)
        this.clearOtpInterval();
        this.timeRemaining = 60;
        let payload = {
          devicetype: "PC",
          deviceos: this.getDeviceOS(),
          mobileno: this.userMobileno,
          country: this.country ? this.country.CountryCode : "",
        };
        this.login(payload)
          .then((response) => {
            if (response.data && response.data.success) {
              this.mobileVerifyLogin();
            } else if (response.data && response.data.errorcode == 6004) {
              return;
            } else if (response.data && response.data.errorcode == 5212) {
              this.formError = showSnackBar(this.$t(response.data.reason), this.$t('DISMISS'));
            } else {
              this.formError = "";
              this.isMobileVerificationPending = true;
              this.verificationResendSms();
              // this.timeRemaining = 60;
              // this.setupOtpInterval();
            }
          })
      },
  
      verifyMobileVerificationPending() {
        if (!this.verifyOtp(this.profilePin)) return;
        let payload = {
          mobileno: this.userMobileno,
          otp: this.profilePin,
          providerid: _providerId,
        };
  
        this.newEmailconfirm(payload)
          .then((response) => {
            if (response.data && response.data.success) {
              this.isMobileVerificationPending = false;
              this.mobileVerifyLogin()
            } else {
              this.formError = this.$t(response.data.reason);
              this.$refs.pinLayout.clearOtpBoxes();
          
            }
          })
  
      },
  
      mobileVerifyLogin() {
        if (!this.verifyOtp(this.profilePin)) return;
        if (this.isMobileVerificationPending) {
          this.verifyMobileVerificationPending()
          return;
        }
        let loginPayload = {
          params: {
            devicetype: "PC",
            deviceos: this.getDeviceOS(),
            mobileno: this.userMobileno,
            country: this.country ? this.country.CountryCode : "",
            otp: this.profilePin,
          },
        };
  
        eventBus.$emit("subscriberLogin", loginPayload);
      },
  
  
      verifyOtp(pin) {
        this.formError = null;
        if (!pin) {
          this.formError = this.$t("Please Enter OTP");
          return false;
        }
        return true;
      },
    },
    beforeDestroy() {
      eventBus.$off("login-response");
      eventBus.$off("signup-lookup-res");
    },
    components: {
      PinLayout: () => import("@/components/utils/PinLayout.vue"),
      JhakaasInput: () => import("@/components/utils/JhakaasInput.vue"),
      Loading: () => import(/* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"),
      DotFlashing: () => import (/* webpackChunkName: "dotFlashing" */ "@/components/Loaders/DotFlashing.vue")
    },
    mixins: [Utility],
  };
  </script>
      
  <style lang="scss" scoped>
  @import "@/sass/_variables.scss";
  @import "@/sass/_components.scss";
  @import "./MobileLogin.scss";
  .form-group, .disclamier, .login-button {
    width: 95%;
    margin: auto;
  }
  .login-button {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    .signup, .dynamic-password {
      display: flex;
      gap: 0.5rem;
      justify-content: center;
      align-items: center;
      &:hover {
        transform: scale(1.05, 1.05);
      }
    }
    .dynamic-password {
      margin-top: 0 !important;
    }
  }

  @media screen and (max-width: 567px) {
    .login-button {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
      .signup, .dynamic-password {
        &:hover {
          cursor: pointer;
          transform: scale(1.1, 1.05);
        }
      }
      .dynamic-password {
        margin-top: 0 !important;
      }
    }  
  }

  .grayText {
    color: #777;
    font-size: 14px;
  }
  </style>
      